<button (click)="skipToContent($event)"
  class="fixed text-vis-white top-0 left-0 rounded-br-lg underline z-50 border-vis-white border-r border-b p-4 -translate-y-full transition-transform"
  [class]="buttonBg ?? 'bg-vis-dark'"
  [ngClass]="{'!translate-y-0': isVisible && !isUsed}"
  (focus)="handleFocus()"
  (blur)="handleBlur()"
  tabindex="0">
  Skip to main content
</button>
